import { render, staticRenderFns } from "./manufacturers.vue?vue&type=template&id=76ce326a"
import script from "./manufacturers.vue?vue&type=script&lang=js"
export * from "./manufacturers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports